import React from 'react';

function statusLabel(status) {
  const map = {
    new: 'Nueva',
    in_review: 'En revision',
    in_route: 'En ruta',
    delivered: 'Entregada',
    canceled: 'Cancelada'
  };
  return map[String(status || '').toLowerCase()] || status || '-';
}

function statusColor(status) {
  const map = {
    new: '#b28b47',
    in_review: '#1d7bc4',
    in_route: '#1d7bc4',
    delivered: '#2e7d32',
    canceled: '#9e3030'
  };
  return map[String(status || '').toLowerCase()] || '#b28b47';
}

function formatDateTime(value) {
  if (!value) return '-';
  const dt = new Date(value);
  if (Number.isNaN(dt.getTime())) return String(value);
  return dt.toLocaleString('es-MX', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  });
}

function nextStatusOptions(currentStatus) {
  const all = ['new', 'in_review', 'in_route', 'delivered', 'canceled'];
  return all.filter((value) => value !== currentStatus);
}

export default function NewspaperRequestsPanel({ adminCtx }) {
  const {
    newspaperRequestsResult,
    loadingNewspaperRequests,
    newspaperFiltersDraft,
    setNewspaperFiltersDraft,
    applyNewspaperFilters,
    changeNewspaperPage,
    changeNewspaperPageSize,
    updateNewspaperRequestStatus
  } = adminCtx;

  return (
    <section className="admin-events-panel">
      <div className="admin-events-header">
        <h2>Seguimiento de solicitudes de periodico</h2>
        <div className="admin-events-head-right">
          <span>
            {loadingNewspaperRequests
              ? 'Cargando...'
              : `${newspaperRequestsResult.total || 0} solicitud(es)`}
          </span>
          <label className="admin-page-size">
            <span>Por pagina</span>
            <select
              value={newspaperRequestsResult.pageSize || 20}
              onChange={(e) => changeNewspaperPageSize(Number(e.target.value))}
              disabled={loadingNewspaperRequests}
            >
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </label>
        </div>
      </div>

      <div className="admin-assemblies-filters">
        <label className="form-field">
          <span className="field-label">Buscar</span>
          <input
            type="text"
            placeholder="Nombre, correo, colonia o calle"
            value={newspaperFiltersDraft.search}
            onChange={(e) =>
              setNewspaperFiltersDraft((prev) => ({ ...prev, search: e.target.value }))
            }
          />
        </label>
        <label className="form-field">
          <span className="field-label">Estatus</span>
          <select
            value={newspaperFiltersDraft.status}
            onChange={(e) =>
              setNewspaperFiltersDraft((prev) => ({ ...prev, status: e.target.value }))
            }
          >
            <option value="">Todos</option>
            <option value="new">Nueva</option>
            <option value="in_review">En revision</option>
            <option value="in_route">En ruta</option>
            <option value="delivered">Entregada</option>
            <option value="canceled">Cancelada</option>
          </select>
        </label>
        <label className="form-field">
          <span className="field-label">Desde</span>
          <input
            type="datetime-local"
            value={newspaperFiltersDraft.from}
            onChange={(e) =>
              setNewspaperFiltersDraft((prev) => ({ ...prev, from: e.target.value }))
            }
          />
        </label>
        <label className="form-field">
          <span className="field-label">Hasta</span>
          <input
            type="datetime-local"
            value={newspaperFiltersDraft.to}
            onChange={(e) =>
              setNewspaperFiltersDraft((prev) => ({ ...prev, to: e.target.value }))
            }
          />
        </label>
        <div className="admin-users-filters-actions">
          <button className="btn-primary" onClick={() => applyNewspaperFilters()}>
            Buscar solicitudes
          </button>
        </div>
      </div>

      <div className="admin-table-wrap">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Folio</th>
              <th>Solicitante</th>
              <th>Cantidad</th>
              <th>Domicilio</th>
              <th>Estatus</th>
              <th>Solicitada</th>
              <th>Actualizar</th>
            </tr>
          </thead>
          <tbody>
            {(newspaperRequestsResult.items || []).length === 0 ? (
              <tr>
                <td colSpan={7} className="admin-empty-cell">
                  No hay solicitudes para los filtros seleccionados.
                </td>
              </tr>
            ) : (
              (newspaperRequestsResult.items || []).map((item) => (
                <tr key={`newspaper-${item.id}`}>
                  <td>SP-{String(item.id).padStart(6, '0')}</td>
                  <td>
                    <strong>{item.requesterName || '-'}</strong>
                    <br />
                    <span className="admin-inline-muted">{item.requesterEmail || '-'}</span>
                  </td>
                  <td>{item.quantity}</td>
                  <td>{item.addressSummary || '-'}</td>
                  <td>
                    <span className="status-badge" style={{ background: statusColor(item.status) }}>
                      {statusLabel(item.status)}
                    </span>
                  </td>
                  <td>{formatDateTime(item.requestedAt)}</td>
                  <td>
                    <div className="newspaper-admin-actions">
                      {nextStatusOptions(item.status).map((status) => (
                        <button
                          key={`req-${item.id}-${status}`}
                          className="btn-ghost btn-sm"
                          onClick={() => {
                            const comment =
                              window.prompt('Comentario de seguimiento (opcional):', '') || '';
                            updateNewspaperRequestStatus(item.id, status, comment);
                          }}
                        >
                          {statusLabel(status)}
                        </button>
                      ))}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div className="admin-pagination">
        <button
          className="btn-ghost"
          onClick={() => changeNewspaperPage((newspaperRequestsResult.page || 1) - 1)}
          disabled={loadingNewspaperRequests || (newspaperRequestsResult.page || 1) <= 1}
        >
          Anterior
        </button>
        <span>
          Pagina {newspaperRequestsResult.page || 1} de {newspaperRequestsResult.totalPages || 1}
        </span>
        <button
          className="btn-ghost"
          onClick={() => changeNewspaperPage((newspaperRequestsResult.page || 1) + 1)}
          disabled={
            loadingNewspaperRequests ||
            (newspaperRequestsResult.page || 1) >= (newspaperRequestsResult.totalPages || 1)
          }
        >
          Siguiente
        </button>
      </div>
    </section>
  );
}
